import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderForwardTaxiTaxiRecalculate from "./billings-order-forward-taxi-taxi-recalculate";
import BillingsOrderForwardTaxiTaxiRecalculateParams from "./billings-order-forward-taxi-taxi-recalculate-params";

const useBillingsOrderForwardTaxiTaxiRecalculate = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderForwardTaxiTaxiRecalculate | null>(null);

  const load = async (
    params: BillingsOrderForwardTaxiTaxiRecalculateParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.recalculateOrderForwardTaxiTaxiBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderForwardTaxiTaxiRecalculate;
